export const PROMO_IDPHYSICPRODUCT = 251;
export const PROMOCODE = 'PREMIUM9';
